/* eslint-disable @typescript-eslint/no-use-before-define */
import React, { useState, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

import useActiveLink from 'core/hooks/useActiveLink';
import { NavListProps } from '../types';
import { StyledPopover } from './styles';
import NavItem from './NavItem';

type NavListRootProps = {
  data: NavListProps;
  depth: number;
  hasChild: boolean;
};

const NavList: React.FC<NavListRootProps> = ({ data, depth, hasChild }) => {
  const navRef = useRef(null);

  const { pathname } = useLocation();

  const { active, isExternalLink } = useActiveLink(data.path);

  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    if (open) {
      handleClose();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  useEffect(() => {
    const appBarEl = Array.from(
      document.querySelectorAll('.MuiAppBar-root'),
    ) as Array<HTMLElement>;

    const styles = () => {
      document.body.style.overflow = '';
      document.body.style.padding = '';
      appBarEl.forEach(elem => {
        // eslint-disable-next-line no-param-reassign
        elem.style.padding = '';
      });
    };

    styles();
  }, [open]);

  return (
    <>
      <NavItem
        ref={navRef}
        item={data}
        depth={depth}
        open={open}
        active={active}
        isExternalLink={isExternalLink}
        onMouseEnter={handleOpen}
        onMouseLeave={handleClose}
      />

      {hasChild && (
        <StyledPopover
          open={open}
          anchorEl={navRef.current}
          anchorOrigin={{ vertical: 'center', horizontal: 'right' }}
          transformOrigin={{ vertical: 'center', horizontal: 'left' }}
          PaperProps={{
            onMouseEnter: handleOpen,
            onMouseLeave: handleClose,
          }}
        >
          <NavSubList data={data.children} depth={depth} />
        </StyledPopover>
      )}
    </>
  );
};

export default NavList;

type NavListSubProps = {
  data: NavListProps[];
  depth: number;
};

const NavSubList = ({ data, depth }: NavListSubProps) => {
  return (
    <>
      {data.map(list => (
        <NavList
          key={list.title + list.path}
          data={list}
          depth={depth + 1}
          hasChild={!!list.children}
        />
      ))}
    </>
  );
};
